import { increaseQty, decreaseQty } from '../components/quantity';

export default function initQuantityHandler() {
    document.body.addEventListener('click', (event) => {
        const plus = event.target.closest('.quantity .plus');
        const minus = event.target.closest('.quantity .minus');

        if (plus) {
            increaseQty(plus); // ✅ fixed
            return;
        }

        if (minus) {
            decreaseQty(minus); // ✅ fixed

            document.body.dispatchEvent(
                new Event('wc_fragments_refreshed')
            );
        }
    });
}